const ViewUser = () => {
  return <div>ViewUser</div>;
};

export default ViewUser;
